import { Flex } from "~/components/Flex";
import { useRiskFactorsConditionBuilder } from "~/pages/security-model/RiskFactorsConfiguration/ConditionBuilder/hooks/useRiskFactorsConditionBuilder";
import { ConditionBuilderAddSelectionRow } from "~/components/ConditionBuilder/ConditionBuilderSelectionRow/ConditionBuilderAddSelectionRow";
import { RiskFactorsConditionSelectionRow } from "~/pages/security-model/RiskFactorsConfiguration/ConditionBuilder/ConditionSelectionRow/RiskFactorsConditionSelectionRow";
import { RiskFactorItem } from "~/pages/security-model/RiskFactorsConfiguration/ConfigurationForm/RiskFactorsConfigurationForm";

export type RiskFactorTagEditorProps = {
  fieldId: string;
  riskFactor: RiskFactorItem;
  isReadonly?: boolean;
  showFormActions?: boolean;
};

export const RiskFactorsConditionBuilder = ({
  fieldId,
  isReadonly = false,
  showFormActions,
}: RiskFactorTagEditorProps) => {
  const {
    fields,
    handleRemoveSelection,
    handleAddNewSelection,
    canAddSelection,
  } = useRiskFactorsConditionBuilder(fieldId);

  return (
    <Flex flexDirection="column" gap={3}>
      {fields.map((_field, selectionIndex) => (
        <RiskFactorsConditionSelectionRow
          fieldId={fieldId}
          selectionIndex={selectionIndex}
          onRemove={() => handleRemoveSelection(selectionIndex)}
          showRemoveSelectionButton={selectionIndex !== 0 && !isReadonly}
          key={_field.id}
          isReadonly={isReadonly}
        />
      ))}
      {fields.length === 0 && (
        <ConditionBuilderAddSelectionRow
          onClick={handleAddNewSelection}
          disabled={!canAddSelection}
          showFormActions={showFormActions}
        />
      )}
    </Flex>
  );
};
